import React from "react";
import ContentLoader from "react-content-loader";

const PoolItemLoader = (props) => (
  <ContentLoader speed={2} width={505} height={305} viewBox="0 0 505 305" backgroundColor="#c0cdd8" foregroundColor="#ecebeb" {...props}>
    <rect x="229" y="29" rx="0" ry="0" width="18" height="0" />
    <rect x="1" y="10" rx="0" ry="0" width="536" height="26" />
    <rect x="8" y="47" rx="0" ry="0" width="61" height="12" />
    <rect x="77" y="46" rx="0" ry="0" width="127" height="13" />
    <rect x="284" y="49" rx="0" ry="0" width="1" height="2" />
    <rect x="274" y="50" rx="0" ry="0" width="19" height="10" />
    <rect x="376" y="47" rx="0" ry="0" width="127" height="13" />
    <rect x="12" y="69" rx="0" ry="0" width="19" height="10" />
    <rect x="12" y="85" rx="0" ry="0" width="19" height="10" />
    <rect x="11" y="101" rx="0" ry="0" width="19" height="10" />
    <rect x="11" y="119" rx="0" ry="0" width="19" height="10" />
    <rect x="11" y="138" rx="0" ry="0" width="19" height="10" />
    <rect x="11" y="156" rx="0" ry="0" width="19" height="10" />
    <rect x="79" y="71" rx="0" ry="0" width="120" height="7" />
    <rect x="82" y="87" rx="0" ry="0" width="120" height="7" />
    <rect x="82" y="103" rx="0" ry="0" width="120" height="7" />
    <rect x="82" y="122" rx="0" ry="0" width="120" height="7" />
    <rect x="83" y="140" rx="0" ry="0" width="120" height="7" />
    <rect x="82" y="157" rx="0" ry="0" width="120" height="7" />
    <rect x="382" y="68" rx="0" ry="0" width="120" height="7" />
    <rect x="384" y="86" rx="0" ry="0" width="120" height="7" />
    <rect x="386" y="103" rx="0" ry="0" width="120" height="7" />
    <rect x="384" y="121" rx="0" ry="0" width="120" height="7" />
    <rect x="387" y="138" rx="0" ry="0" width="120" height="7" />
    <rect x="384" y="154" rx="0" ry="0" width="120" height="7" />
    <rect x="163" y="175" rx="0" ry="0" width="240" height="16" />
    <rect x="164" y="196" rx="0" ry="0" width="240" height="16" />
    <rect x="164" y="217" rx="0" ry="0" width="240" height="16" />
    <rect x="165" y="239" rx="0" ry="0" width="240" height="16" />
    <rect x="387" y="265" rx="0" ry="0" width="88" height="25" />
  </ContentLoader>
);

export default PoolItemLoader;
